/** HUD de desempenho (depuração): texto simples, atualizado 4 vezes por segundo. */
export class StatsHud {
  private readonly element: HTMLElement;
  private last = 0;

  constructor(parent: HTMLElement, id = "stats") {
    this.element = document.createElement("pre");
    this.element.id = id;
    Object.assign(this.element.style, {
      position: "fixed",
      left: "8px",
      top: "8px",
      margin: "0",
      padding: "6px 8px",
      font: "12px/1.35 ui-monospace, Menlo, monospace",
      color: "#f3ead7",
      background: "rgba(14, 26, 20, 0.72)",
      borderRadius: "6px",
      pointerEvents: "none",
      whiteSpace: "pre",
      zIndex: "10",
    });
    parent.appendChild(this.element);
  }

  set visible(on: boolean) {
    this.element.hidden = !on;
  }

  remove(): void {
    this.element.remove();
  }

  update(now: number, lines: () => string[]): void {
    if (now - this.last < 250) return;
    this.last = now;
    this.element.textContent = lines().join("\n");
  }
}
